import { dispatchNewSearchRadar } from 'reactApp/modules/dwh/dwh.module';
import { downloadMobileItem as downloadMobileItemAction } from 'reactApp/modules/modifying/modifying.actions';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { store as reduxStore } from 'reactApp/store';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import { getSelectedItems } from '../toolbarActions/helpers/getSelectedItems';

export const downloadMobileItem = () => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const selected = getSelectedItems(state);

    reduxStore.dispatch(downloadMobileItemAction());

    if (currentStorage === 'search') {
        const dwhData = {
            eventCategory: ECategoryGa.toolbar_search,
            action: 'download-files',
            count_files: selected.length || 1,
        };
        const items = selected.map((item) => ({
            file_name: 'nameWithoutExt' in item && item.nameWithoutExt,
            file_id: item.id,
            pos: 'pos' in item && item.pos,
            type: item.kind,
            placement: 'srchSrc' in item && item.srchSrc,
        }));

        reduxStore.dispatch(dispatchNewSearchRadar({ dwhData, items }));
    }
};
